/* eslint-disable jira/filename-case */
import { setupConnectJs } from '@jira/platform__connect/src/index.tsx';
import type { Action } from '../types.tsx';

export const withConnectHost = async (action: Action): Promise<void> => {
	const connectHost = await setupConnectJs();
	action(connectHost);
};

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getConnectHost = (): any => window.connectHost; // oxlint-disable-line @typescript-eslint/no-explicit-any

export const isConnectDialogWebItem = (classes: string | string[]): boolean =>
	classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');
